app-speedbump {
	app-dialog {
		.dialog {
			min-width: min(315px, 80vw);
			inline-size: unset;
			max-width: min(700px, 80vw);
			border-radius: 0.25rem;
			padding-block:  1.25rem;
			padding-inline: 1.5rem;

			header {
				margin-block-end: 1rem;

				p {
					padding-block-end: 0;
				}
			}

			.dialog__body {
				padding: 0;
				padding-block-end: 1.5rem;

				p:last-of-type {
					padding-block-end: 0;
				}
			}

			footer form {
				display: flex;
				flex-wrap: wrap;
				gap: 0.5rem;

				@include media-breakpoint-down(sm) {
					.btn {
						inline-size: 100%;
					}
				}
			}
		}
	}
}
